<template>
<div class="show-impedance pt-2 pb-3">
    <div class="row">
      <div class="col-md-6 pl-0">
        <h6 class="is-bold text-evollu-gray-light mb-3">
          {{ title }}
        </h6>
      </div>

      <div class="col-md-6 text-right" v-if="value && value.updated_at !== null && value.updated_at !== undefined">
        <small>
          {{ $t('clinical.people.anamnesis.updated_at') }}
        </small>
        <small class="is-bold">
          {{$t('clinical.people.anamnesis.updated_by', {date: getExpressiveDate(value.updated_at), name: value.updated_by ? value.updated_by.name : ''})}}
        </small>
      </div>
    </div>
    <section v-if="value !== null && value !== undefined" class="px-2">

      <!-- Impedance Right Ear Result-->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.right_ear')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.right_ear_impedance_result)}}
        </span>
      </div>

      <!-- Impedance Right Ear Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.right_ear_obs')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.right_ear_obs)}}
        </span>
      </div>

      <!-- Impedance Left Ear Result-->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.left_ear')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.left_ear_impedance_result)}}
        </span>
      </div>

      <!-- Impedance Left Ear Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.left_ear_obs')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.left_ear_obs)}}
        </span>
      </div>

      <!-- Impedance Ipsilateral Reflexes-->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.ipsilateral_reflexes')}}:
        </label>
        <span class="is-bold">
          {{getBooleanAnswer(value.ipsilateral_reflexes)}}
        </span>
      </div>

      <!-- Impedance Ipsilateral Reflexes Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.ipsilateral_reflexes_obs')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.ipsilateral_reflexes_obs)}}
        </span>
      </div>

      <!-- Impedance Contralateral Reflexes-->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.contralateral_reflexes')}}:
        </label>
        <span class="is-bold">
          {{getBooleanAnswer(value.contralateral_reflexes)}}
        </span>
      </div>

      <!-- Impedance Contralateral Reflexes Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.contralateral_reflexes_obs')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.contralateral_reflexes_obs)}}
        </span>
      </div>

      <!-- Impedance Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.general_obs')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.obs)}}
        </span>
      </div>

    </section>

    <section v-else class="px-2">
      <span>{{$t('clinical.people.no_data')}}</span>
    </section>
  </div>

</template>

<script>
import * as AnamnesisOptions from './AnamnesisOptions'
export default {
  props: {
    value: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('clinical.people.anamnesis.impedance')
      }
    }
  },
  data: function () {
    return {
      formOptions: AnamnesisOptions
    }
  },
  methods: {
    getExpressiveDate: function (value) {
      if (value) {
        if (this.$options.filters.isToday(value)) {
          return this.$t('date_helpers.today')
        } else {
          return this.$options.filters.localTime(value, `DD [${this.$t('date_helpers.day_of_month_separator')}] MMMM [${this.$t('date_helpers.day_of_month_separator')}] YYYY`, '', this.locale)
        }
      }
      return ''
    },
    getTextAnswer: function (answer, defaultValue = 'N/A') {
      return answer || defaultValue
    },
    getBooleanAnswer: function (answer, defaultValue = 'N/A') {
      return answer === null ? defaultValue : (answer === true ? this.$t('yes') : this.$t('no'))
    },
    getSingleOptionAnswer: function (options, answerId, defaultValue = 'N/A') {
      let option = null
      if (answerId !== null) {
        option = options.find(option => option.id === answerId)
        if (option) {
          option = this.$t(option.name)
        }
      }
      return option || defaultValue
    }
  }
}
</script>
<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

.answer-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  justify-content: flex-start;

  label {
    margin-bottom: 0rem;
  }

  @include for-desktop {
    flex-direction: row;
    align-items: center;

    label {
      max-width: 80%;
    }

    span {
      margin-left: 0.25rem;
    }
  }
}

</style>
